import { useAppState } from './AppStateProvider';
import { useAppcuesPageChange } from './hooks/useAppcuesPageChange';
import { useOnceWhenOpen } from './hooks/useOnceWhenOpen';
import { routingConfig } from './routingConfig';
import { loadAppcues } from './services/appcues';
import { usePageViewTracking } from './services/tracking/hooks/usePageViewTracking';

export const Router = () => {
  const { page, isOpen } = useAppState();
  const PageView = routingConfig.find((config) => config.page === page)?.component;

  usePageViewTracking();
  useOnceWhenOpen(isOpen, loadAppcues);
  useAppcuesPageChange(page);

  return PageView ? <PageView /> : null;
};
